import type TableView from "../store/schema/TableView";
import folderStore, { getSearchFolderHasUnreadRestriction } from "owa-folders";
import type SearchFolderTemplateId from "owa-service/lib/contract/SearchFolderTemplateId";

// Determines whether the table view is showing a search folder which is one of the Unread types
export default function isUnreadSearchFolder(tableView: TableView): boolean {
    if (!tableView) {
        return false;
    }
    
    const folderId = tableView.tableQuery.folderId;
    const folder = folderStore().folderTable.get(folderId);
    if (folder?.SearchFolderTemplateId == null) {
        return false;
    }
    
    if (SearchFoldersWithUnreadFilter.indexOf(folder.SearchFolderTemplateId) > -1) {
        return true;
    }
    
    // Custom search folders (e.g. "Unread mail" created in OWA, optionally scoped to specific folders)
    // use the CUSTOM template, so check their restriction instead
    return (folder.SearchFolderTemplateId === 1 &&
        !!getSearchFolderHasUnreadRestriction(folderId));
}

const SearchFoldersWithUnreadFilter: SearchFolderTemplateId[] = [
    2,
    4,
];
